<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12" lg="12">
        <TheMatriculasTable />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Formularios",
  components: {
    TheMatriculasTable: () =>
      import(
        "@/components/dashboardComponents/TheMatriculasTable"
      ),
  },
  data: () => ({
    page: {
      title: "Matrículas"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Home",
        disabled: false,
        href: "/dashboard/index/"
      },
      {
        text: "Matrículas",
        disabled: true,
        href: "/dashboard/matriculas/"
      }
    ]
  })
};
</script>
